import axios from 'axios'
import { getTokens } from './getTokens';
import { StorageCookies } from './storage_cookies';
import Cookies from 'js-cookie';

export const api = axios.create({
    // baseURL: 'https://j2o0re.deta.dev'
    baseURL: 'https://api.schiefler.adv.br'
});
export const login_api = axios.create({
    // baseURL: 'https://j2o0re.deta.dev'
    baseURL: 'https://api.schiefler.adv.br'
});


api.interceptors.request.use(
    config => {
        if (!config.headers['Authorization']) {
            const auth = getTokens()
            config.headers['Authorization'] = `Bearer ${auth?.access_token}`;
            api.defaults.headers['Authorization'] = `Bearer ${auth?.access_token}`
        }
        return config;
    }, (error) => Promise.reject(error)
)

api.interceptors.response.use(
    response => response,
    async (error) => {
        const prevRequest = error?.config;
        if ((error?.response?.status === 403 || error?.response?.status === 401) && !prevRequest?.sent) {
            prevRequest.sent = true;
            let newTokens
            try {
                newTokens = await doRefreshToken()
            } catch (error) {
                console.log("🚀 ~ error:", error)

            } finally {
                if (newTokens?.access_token && newTokens?.refresh_token) {
                    StorageCookies({ access_token: newTokens?.access_token, refresh_token: newTokens?.refresh_token })
                    api.defaults.headers.Authorization = `Bearer ${newTokens?.access_token}`;
                    prevRequest.headers.Authorization = `Bearer ${newTokens?.access_token}`
                } else {
                    const auth = getTokens()
                    api.defaults.headers.Authorization = `Bearer ${auth?.access_token}`;
                    prevRequest.headers.Authorization = `Bearer ${auth?.access_token}`
                }
            }
            const auth = getTokens()
            return api({
                ...prevRequest,
                headers: { ...prevRequest.headers, Authorization: `Bearer ${auth?.access_token}` },
                sent: true
            })
        }
        return Promise.reject(error)
    }
)

// login
const { refresh_token } = getTokens()

export const doRefreshToken = async () => {
    login_api.defaults.headers['Authorization'] = `Bearer ${refresh_token}`
    try {
        const response = (await login_api.post('/auth/refresh')).data
        return response
    } catch (error) {

        const c_projects = Cookies.get('projects')
        if (c_projects) {
            const projects = JSON.parse(c_projects)
            projects.map((project) => {
                const id = project.id.toString()
                const test = Cookies.get(id)
                if (test) {
                    Cookies.remove(id)
                }
            })
        }
        Cookies.remove('access_token')
        Cookies.remove('refresh_token')
        Cookies.remove('user')
        Cookies.remove('projects')
    }
}

export const createSession = async (email, password) => {
    return login_api.post('/auth/login', { username: email, password, scope: "me:read asana:read asana:create" }, { headers: { 'Content-Type': 'multipart/form-data' } });
}

export const getUserData = async () => {
    return api.get('/cliente/user/');
}
export const updateUserData = async (data) => {
    return api.put('/cliente/user/personal', data);
}
export const getPersonalData = async () => {
    return api.get('/cliente/user/personal');
}

export const getAsanaProjects = async () => {
    return api.get('/cliente/projects/all');
}

export const getTasks = async (id) => {
    return await api.get(`cliente/projects/tasks/${id}`);
}

export const getContratos = async (project_id) => {
    return api.get(`/cliente/contracts/${project_id}`);
}
export const downloadContrato = async (project_id) => {
    return api.get(`/cliente/contracts/download/${project_id}`, { responseType: 'arraybuffer' })
}
export const postOrder = async (id, newTask) => {
    return api.post(`/cliente/projects/tasks/${id}/new/`, newTask);
}

export const getPendecy = async () => {

    return api.get('/cliente/user/pendencies');
}